import {
	Chip,
	FormControl,
	Input,
	InputLabel,
	MenuItem,
	Select,
	type Theme,
	makeStyles,
	useTheme,
} from "@material-ui/core";
import { get } from "lodash-es";
// @flow
import * as React from "react";
import { useEffect, useMemo, useState } from "react";
import type { AuthType } from "../../models/AuthType";
import { getAuthTypes } from "../../repositories/UsersRepository";

const useStyles = makeStyles((theme: Theme) => ({
	root: {
		"& .MuiSelect-select": {
			minHeight: "40px",
		},
	},
	formControl: {
		width: "100%",
		marginTop: 8,
	},
	chips: {
		display: "flex",
		flexWrap: "wrap",
	},
	chip: {
		margin: 2,
	},
	noLabel: {
		marginTop: theme.spacing(3),
	},
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

type Props = {
	value: number | null;
	onChange: (val: number) => void;
	disabled?: boolean;
};
export const AuthTypeSelector = ({ value, onChange, disabled }: Props) => {
	const classes = useStyles();
	const [authTypes, setAuthTypes] = useState<AuthType[]>([]);
	const [isLoading, setIsLoading] = useState(true);
	const theme = useTheme();
	const [error, setError] = useState("");

	const getStyles = (
		AuthTypeId: number,
		authTypes: AuthType[],
		theme: Theme,
	) => {
		return {
			fontWeight: !!authTypes.find((p) => p.AuthTypeId === AuthTypeId)
				? theme.typography.fontWeightRegular
				: theme.typography.fontWeightMedium,
		};
	};

	function getAuthNameById(AuthTypeId: number) {
		return authTypes.find((p) => p.AuthTypeId === AuthTypeId)?.Name || "";
	}

	const selectedAuthTypeName = useMemo(() => {
		return (
			authTypes.find((authType) => authType.AuthTypeId === value)?.Name ||
			"Empty"
		);
	}, [authTypes, value]);

	useEffect(() => {
		setIsLoading(true);
		getAuthTypes().then((resp) => {
			if (resp.ok) {
				setAuthTypes(get(resp, "data.tables[0].rows", []));
				setIsLoading(false);
			} else {
				setIsLoading(false);
				setError(resp.message);
			}
		});
	}, []);

	return (
		<div className={classes.root}>
			{!isLoading && authTypes.length ? (
				<FormControl className={classes.formControl} disabled={disabled}>
					<InputLabel id="demo-mutiple-chip-label">Auth type</InputLabel>
					<Select
						autoWidth={true}
						labelId="demo-mutiple-chip-label"
						id="demo-mutiple-chip"
						value={value}
						style={{ padding: 0 }}
						onChange={onChange as any}
						input={<Input id="select-multiple-chip" />}
						renderValue={(selected) => (
							<div className={classes.chips}>
								<Chip
									key={`selected-authType-${selected}`}
									label={selectedAuthTypeName}
									className={classes.chip}
								/>
							</div>
						)}
						MenuProps={MenuProps}
					>
						{authTypes.map((authType) => (
							<MenuItem
								key={`auth-${authType.AuthTypeId}`}
								value={authType.AuthTypeId}
								style={getStyles(authType.AuthTypeId, authTypes, theme)}
							>
								{authType.Name}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			) : (
				<></>
			)}
		</div>
	);
};
